import png from './images/roosters.png'

export const colors = {
  dominant: '#00305E',
  highlight: '#fcb53e',
}
export const fullname = 'Roosters'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/roosters.js